import api from 'services/api';

const buildRequestBody = ({ data_inicio, data_fim, filters = undefined, retry = false }) => ({
  data_inicio,
  data_fim,
  ...(Array.isArray(filters) && filters.length > 0 ? { filters } : {}),
  ...(retry ? { retry: true } : {}),
});

class InfraestruturaRowsService {
  async buscarRows({ data_inicio, data_fim, filters = undefined, retry = false }, signal = null) {
    const config = signal ? { signal } : {};
    const body = buildRequestBody({ data_inicio, data_fim, filters, retry });
    const response = await api.post('/infraestrutura/os', body, config);

    if (response.status === 202 || response.data?.status === 'processing') {
      return {
        status: 'processing',
        progress: response.data?.progress || null,
        rows: [],
        evolution: this.normalizeEvolution(response.data?.evolution),
      };
    }

    return {
      status: 'ready',
      rows: Array.isArray(response.data?.rows) ? response.data.rows : [],
      evolution: this.normalizeEvolution(response.data?.evolution),
    };
  }

  async buscarEvolution({ data_inicio, data_fim, filters = [], retry = false }, signal = null) {
    const config = signal ? { signal } : {};
    const body = buildRequestBody({ data_inicio, data_fim, filters, retry });
    const response = await api.post('/infraestrutura/os/evolution', body, config);

    return {
      status: response.status === 202 || response.data?.status === 'processing' ? 'processing' : 'ready',
      evolution: this.normalizeEvolution(response.data?.evolution),
    };
  }

  normalizeEvolution(evolution) {
    return {
      months: Array.isArray(evolution?.months) ? evolution.months : [],
      scope: typeof evolution?.scope === 'string' ? evolution.scope : 'general',
      requested_scope: typeof evolution?.requested_scope === 'string' ? evolution.requested_scope : 'general',
      cache_state: typeof evolution?.cache_state === 'string' ? evolution.cache_state : 'stale',
      last_updated: typeof evolution?.last_updated === 'string' ? evolution.last_updated : null,
      filter_hash: typeof evolution?.filter_hash === 'string' ? evolution.filter_hash : null,
    };
  }
}

const infraestruturaRowsService = new InfraestruturaRowsService();

export default infraestruturaRowsService;
